<template>
  <nav class="AtlasIndicatorControls">
    <div
      v-if="displayedCategoriesList.length || displayedLinksList.length"
      class="AtlasIndicatorControls-chooseIndicator"
    >
      <div
        v-if="displayedCategoriesList.length"
        class="AtlasIndicatorControls-ctrl AtlasIndicatorControls-ctrl--category"
      >
        <div class="AtlasIndicatorControls-label">Indicator group</div>
        <atlas-select
          :options="displayedCategoriesList"
          @choose="onChooseCategory"
        />
      </div>

      <div
        v-if="displayedLinksList.length"
        class="AtlasIndicatorControls-ctrl AtlasIndicatorControls-ctrl--indicator"
      >
        <div class="AtlasIndicatorControls-label">Choose your indicator</div>
        <atlas-select
          :options="displayedLinksList"
          @choose="onChooseIndicator"
        />
      </div>
    </div>
  </nav>
</template>

<script>
import { defineComponent, computed, ref, watch } from 'vue';
import AtlasSelect from '../widget/select.vue';

export default defineComponent({
  components: {
    AtlasSelect,
  },

  props: {
    categories: {
      type: Array,
      default: () => [],
    },

    links: {
      type: Array,
      default: () => [],
    },
    standalone: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:indicator'],
  setup(props, { emit }) {
    const categoriesList = ref(props.categories);
    const linksList = ref(props.links);

    const displayedCategoriesList = computed(() => {
      return categoriesList.value;
    });

    const category = computed(() => {
      return displayedCategoriesList.value.find((cat) => cat.isActive) || {};
    });

    const displayedLinksList = computed(() => {
      return linksList.value.filter(
        (link) => link?.category === category.value.id,
      );
    });

    const onChoose = (options, selected) => {
      return options.map((item) => {
        return { ...item, isActive: item.id === selected.id };
      });
    };

    const onChooseCategory = ({ option }) => {
      categoriesList.value = onChoose(categoriesList.value, option);
    };
    const onChooseIndicator = ({ option }) => {
      linksList.value = onChoose(linksList.value, option);

      emit('update:indicator', option);
    };

    // After receiving the indicator links,
    // we get the active category and assign it
    // (it is necessary for the correct display of the category
    // if isActive is selected for the wrong category).
    watch(
      () => props.links,
      (links) => {
        const activeLink = links.find((link) => link?.isActive);
        if (
          activeLink?.category &&
          activeLink?.category !== category.value.id
        ) {
          categoriesList.value = onChoose(categoriesList.value, {
            id: activeLink.category,
          });
        }
      },
      { immediate: true },
    );

    return {
      displayedCategoriesList,
      displayedLinksList,
      onChooseCategory,
      onChooseIndicator,
    };
  },
});
</script>

<style lang="scss">
.AtlasIndicatorControls {
  margin-bottom: 30px;

  @media screen and (min-width: 1024px) {
    display: flex;
  }

  &-chooseIndicator {
    flex: 330;
    margin-bottom: 15px;

    @media screen and (min-width: 640px) {
      display: flex;
    }

    @media screen and (min-width: 1024px) {
      margin-bottom: 0;
    }
  }

  &-chooseGeo {
    flex: 620;
  }

  &-ctrl {
    margin-right: 30px;

    &--category {
      flex: 1;
      margin-bottom: 15px;

      @media screen and (min-width: 640px) {
        margin-bottom: 0;
      }
    }

    &--indicator {
      flex: 2;
    }
  }

  &-label {
    margin-bottom: 11px;
    color: color(shadow);
    font-size: 14px;
    font-weight: normal;
    white-space: nowrap;
  }
}
</style>
